import { CreatePointsResponse, GetTopicResponse, ProcessGptPlacesRequest, SuggestGptPlaces, TtmGptJsonContentResponse, TtmGptJsonGeneralResponse } from '../../types';
import { buildQueryString, logWithAmplitude, post, throwHttpError } from './api';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getFromLocalStorage, isDefined, isValidString, undefinedIfEmpty } from '../utils';

import accountInfo from '../state/account-info';
import { iterateAICount } from './account-api';

export async function processSuggestedPoints(
    amplitude_callsite: string,
    suggestion_content: SuggestGptPlaces,
    email?: string,
    topic_id?: string,
    topic_key?: string,
) : Promise<TtmGptJsonContentResponse> {

    const queryString = buildQueryString({ email, topic_id, topic_key });

    const response = await fetch(`/api/gpt/points_suggest${queryString}`, post(suggestion_content));

    if (!response.ok) {
        await throwHttpError('An error occurred while getting the team backpack topics.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get Gpt Suggested Points', {
        email,
        topic_id,
    });

    return await (response.json() as Promise<TtmGptJsonContentResponse>);
}


export async function addSuggestedPointsToMap (
    amplitude_callsite: string,
    points: ProcessGptPlacesRequest,
    topic_key?:String,
) : Promise<CreatePointsResponse> {
    let queryString = '';
    if (topic_key) {
        queryString = buildQueryString({ topic_key });
    }

    const response = await fetch(`/api/gpt/points_process${queryString}`, post(points));


    if (!response.ok) {
        await throwHttpError('An error occurred while adding the suggested points to the map.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Add Suggested Points To Map', {
        topic_id: points.topic_id,
    });

    return await (response.json() as Promise<CreatePointsResponse>);
}


export async function promptToInitializedMapAI(amplitude_callsite: string, text: string, email: string, center_location?: string, topic_id?: string, topic_key?: string): Promise<TtmGptJsonGeneralResponse> {
    text = text.replace(/\n/g, ':');
    const queryString = buildQueryString({ topic_id: undefinedIfEmpty(topic_id), topic_key: undefinedIfEmpty(topic_key) });
    const body = {
        location: center_location,
        email,
        creation_method: {
            prompt: text
        }
    };

    // try up to 3 times to handle occasional AI errors
    let response;
    for (let i = 0; i < 3; i++) {
        try {
            response = await fetch(`/api/gpt/topic_suggest${queryString}`, post(body));
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            break;
        } catch (error) {
            console.error(`Attempt ${i + 1} failed with error}`);
            if (i === 2) {
                throw error;
            }
        }
    }

    if (response === undefined) {
        throw new Error('AI Set up Response is undefined');
    }

    // Bypass AI limits for now

    logWithAmplitude(amplitude_callsite, 'Prompt-to-Initialized-Map AI Call', {
        organization_id: getFromLocalStorage('organization_id'),
    });

    return await (response.json() as Promise<TtmGptJsonGeneralResponse>);
}

export async function textToMapAI(amplitude_callsite: string, text: string, organizationId?: string): Promise<GetTopicResponse> {
    // replace line breaks in text with colons
    text = text.replace(/\n/g, ':');

    const body_individual = {
        text,
        email: accountInfo.email,
    };

    const body_organization = {
        text,
        email: accountInfo.email,
        organization_id: {
            $oid: organizationId
        }
    };

    const body = organizationId ? body_organization : body_individual;


    const response = await fetch(`/api/gpt/topic_create`, post(body));

    if (!response.ok) {
        await throwHttpError('An error occurred while building the map.', response);
    }

    await iterateAICount(amplitude_callsite);

    logWithAmplitude(amplitude_callsite, 'Text-To-Map AI Call', {
        organization_id: getFromLocalStorage('organization_id'),
    });

    return await (response.json() as Promise<GetTopicResponse>);
}

export async function gptCall(amplitude_callsite: string, prompt: string): Promise<any> {
    const body = {
        prompt
    };

    logWithAmplitude(amplitude_callsite, 'GPT Passthrough AI Call');

    const response = await fetch(`/api/gpt/passthrough`, post(body));
    const reader = response.body?.getReader();

    let result = '';

    if (reader) {
        while (true) {
            const { done, value } = await reader.read();

            if (done) {
                break;
            }

            result += new TextDecoder().decode(value);
        }
    }

    const formattedResult = JSON.parse(result);

    const text_respose = formattedResult.choices[0].message.content;

    return text_respose;
}
